import { isPossiblePhoneNumber } from 'react-phone-number-input';

import { CollectionSurveyQuestions } from '@src/generated/hooks';
import { getErrorMessage } from '../utils/validation';

/**
 * @name validatePhone
 * @description Use built-in validation
 */
export const validatePhone = (
  question: CollectionSurveyQuestions,
  answer?: string
): string => {
  const { required, type } = question;

  if (type !== 'phone') {
    throw new Error('Invalid question type');
  }

  // Not required and no value to validate
  if (!required && !answer) return '';

  const isValid = answer ? isPossiblePhoneNumber(answer, 'US') : false;

  return isValid ? '' : getErrorMessage(question);
};
